import {MouseEvent} from "react";
import {css, cx} from "@panda/css";
import {useFormikContext} from "formik";

import {Text} from "@pg-design/text-module";
import {FormikForm} from "@pg-mono/formik-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {mktOptinsCopy} from "../../../../lead/constants/mkt_optins_copy";
import {hitMktOptinClick} from "../../../tracking/hit_mkt_optin_click";
import {IApplicationFormValues} from "../../../types/IApplicationFormValues";
import {useApplicationFormContext} from "../ApplicationFormContext";

interface IProps {
    showMktSmsField: boolean;
    showMktEmailField: boolean;
    className?: string;
}

export const ApplicationOptIns = (props: IProps) => {
    const {showMktSmsField, showMktEmailField, className} = props;
    const {source, sourceSection} = useApplicationFormContext();
    const {errors, touched} = useFormikContext<IApplicationFormValues>();

    if (!showMktEmailField && !showMktSmsField) {
        return null;
    }

    return (
        <div className={cx(className, optinsWrap)}>
            <Text variant="info_txt_2" as="span">
                {mktOptinsCopy}
            </Text>
            {showMktEmailField && (
                <div className={emailCheckboxWrap}>
                    <FormikForm.Checkbox
                        id={`mkt_email_${source}_${sourceSection}`}
                        name="marketing_email"
                        labelContent={
                            <Text as="span" variant="info_txt_1" dataTestId={OFFER_TEST_IDS.LEAD_FORM.EMAIL_CONSENT_CHECKBOX}>
                                o adres email
                                <Text as="span" variant="info_txt_1" className={redStar}>
                                    *
                                </Text>
                            </Text>
                        }
                        css={checkboxStyle}
                        onClick={(event: MouseEvent<HTMLInputElement>) => {
                            hitMktOptinClick(event.currentTarget.checked, "email");
                        }}
                    />
                    {errors.marketing_email && touched.marketing_email && (
                        <Text as="div" variant="info_txt_3" className={errorText}>
                            {errors.marketing_email}
                        </Text>
                    )}
                </div>
            )}
            {showMktSmsField && (
                <FormikForm.Checkbox
                    id={`mkt_sms_${source}_${sourceSection}`}
                    name="marketing_sms"
                    labelContent={
                        <Text as="span" variant="info_txt_1" dataTestId={OFFER_TEST_IDS.LEAD_FORM.PHONE_CONSENT_CHECKBOX}>
                            o numer telefonu
                        </Text>
                    }
                    css={checkboxStyle}
                    onClick={(event: MouseEvent<HTMLInputElement>) => {
                        hitMktOptinClick(event.currentTarget.checked, "sms");
                    }}
                />
            )}
        </div>
    );
};

const optinsWrap = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const redStar = css({
    color: "var(--colors-danger)"
});

const errorText = css({
    color: "var(--colors-danger)",
    marginTop: "0.25rem"
});

const checkboxStyle = css({
    alignItems: "flex-start"
});

const emailCheckboxWrap = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});
import {MouseEvent} from "react";
import {css, cx} from "@panda/css";
import {useFormikContext} from "formik";

import {Text} from "@pg-design/text-module";
import {FormikForm} from "@pg-mono/formik-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {mktOptinsCopy} from "../../../../lead/constants/mkt_optins_copy";
import {hitMktOptinClick} from "../../../tracking/hit_mkt_optin_click";
import {IApplicationFormValues} from "../../../types/IApplicationFormValues";
import {useApplicationFormContext} from "../ApplicationFormContext";

interface IProps {
    showMktSmsField: boolean;
    showMktEmailField: boolean;
    className?: string;
}

export const ApplicationOptIns = (props: IProps) => {
    const {showMktSmsField, showMktEmailField, className} = props;
    const {source, sourceSection} = useApplicationFormContext();
    const {errors, touched} = useFormikContext<IApplicationFormValues>();

    if (!showMktEmailField && !showMktSmsField) {
        return null;
    }

    return (
        <div className={cx(className, optinsWrap)}>
            <Text variant="info_txt_2" as="span">
                {mktOptinsCopy}
            </Text>
            {showMktEmailField && (
                <div className={emailCheckboxWrap}>
                    <FormikForm.Checkbox
                        id={`mkt_email_${source}_${sourceSection}`}
                        name="marketing_email"
                        labelContent={
                            <Text as="span" variant="info_txt_1" dataTestId={OFFER_TEST_IDS.LEAD_FORM.EMAIL_CONSENT_CHECKBOX}>
                                o adres email
                                <Text as="span" variant="info_txt_1" className={redStar}>
                                    *
                                </Text>
                            </Text>
                        }
                        css={checkboxStyle}
                        onClick={(event: MouseEvent<HTMLInputElement>) => {
                            hitMktOptinClick(event.currentTarget.checked, "email");
                        }}
                    />
                    {errors.marketing_email && touched.marketing_email && (
                        <Text as="div" variant="info_txt_3" className={errorText}>
                            {errors.marketing_email}
                        </Text>
                    )}
                </div>
            )}
            {showMktSmsField && (
                <FormikForm.Checkbox
                    id={`mkt_sms_${source}_${sourceSection}`}
                    name="marketing_sms"
                    labelContent={
                        <Text as="span" variant="info_txt_1" dataTestId={OFFER_TEST_IDS.LEAD_FORM.PHONE_CONSENT_CHECKBOX}>
                            o numer telefonu
                        </Text>
                    }
                    css={checkboxStyle}
                    onClick={(event: MouseEvent<HTMLInputElement>) => {
                        hitMktOptinClick(event.currentTarget.checked, "sms");
                    }}
                />
            )}
        </div>
    );
};

const optinsWrap = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const redStar = css({
    color: "var(--colors-danger)"
});

const errorText = css({
    color: "var(--colors-danger)",
    marginTop: "0.25rem"
});

const checkboxStyle = css({
    alignItems: "flex-start"
});

const emailCheckboxWrap = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});
